import { render, staticRenderFns } from "./DocUniverseView.vue?vue&type=template&id=5b21ee68&"
import script from "./DocUniverseView.vue?vue&type=script&lang=js&"
export * from "./DocUniverseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports